import React from 'react'
import { Link } from 'react-router-dom'

const Logo = ({ isMobile = false }) => {
  if (isMobile) {
    return (
      <Link to="/" className="flex items-center">
        <img src="/img/logo-mobile.png" alt="logo" className="w-[33px]" />
      </Link>
    )
  }

  return (
    <Link to="/">
      <img src="/img/logo.png" alt="logo" className="w-36" />
    </Link>
  )
}

export default Logo
